<template>
    <v-container class="ma-0 pa-0 pb-8">
        <div class="pt-6 px-8 pb-6">
            <v-row class="ma-0 mb-2">
                <strong>Filtros</strong>
                <v-spacer></v-spacer>
                <v-btn @click="removeFilter()" small class="elevation-0" style="border:solid 1px #dddddd;">
                    <v-icon small class="mr-1">mdi-filter-off</v-icon>Limpiar
                </v-btn>
            </v-row>

            <v-select v-model="items.publish" clearable :items="publishOptions" label="Publicado"></v-select>

            <v-select v-model="items.facturapi_validation" clearable :items="facturapiOptions" label="Validación Facturapi"></v-select>

            <v-select v-model="items.inventory_stock" clearable :items="inventoryStockOptions" label="Existencias"></v-select>

            <v-autocomplete
                v-model="items.brand"
                :items="brands"
                item-text="name"
                item-value="id"
                attach
                chips
                label="Marca"
                multiple
                clearable
                @keydown.enter="filter()"
            ></v-autocomplete>

            <v-autocomplete
                v-model="items.category"
                :items="categories"
                item-text="name"
                item-value="id"
                attach
                chips
                label="Categoría"
                multiple
                clearable
                @keydown.enter="filter()"
            ></v-autocomplete>
        </div>
        <v-card style="position:absolute; bottom:0; width:100%;" tile color="primary">
            <v-list-item link @click="filter()" dark>
                <v-list-item-content>
                    <strong>Filtrar ({{filtersLength}})</strong>
                </v-list-item-content>
            </v-list-item>
        </v-card>
    </v-container>
</template>

<script>
export default {
    data: () => ({
        items:{
            category:[],
            brand:[],
            publish:'',
            facturapi_validation:'',
            inventory_stock:'',
        },
        publishOptions:[
            {text:'Publicados', value:1},
            {text:'No Publicados', value:0},
            {text:'Todos', value:''}
        ],
        facturapiOptions:[
            {text:'Validados', value:1},
            {text:'No validados', value:0},
            {text:'Todos', value:''}
        ],
        inventoryStockOptions:[
            {text:'Con existencias', value:'with_stock'},
            {text:'Sin existencias', value:'without_stock'},
            {text:'Todos', value:''}
        ]
    }),
    created(){
        const savedFilters = localStorage.getItem('selectorFiltersInventoryPos')
        if(savedFilters){
            this.items = {
                ...this.defaultItems(),
                ...JSON.parse(savedFilters),
            }
        }
    },
    computed: {
        filtersLength(){
            var count = 0
            if(this.items.publish !== '' && this.items.publish !== null && this.items.publish !== undefined){
                count++
            }
            if(this.items.facturapi_validation !== '' && this.items.facturapi_validation !== null && this.items.facturapi_validation !== undefined){
                count++
            }
            if(this.items.inventory_stock !== '' && this.items.inventory_stock !== null && this.items.inventory_stock !== undefined){
                count++
            }
            if(this.items.brand && this.items.brand.length > 0){
                count++
            }
            if(this.items.category && this.items.category.length > 0){
                count++
            }
            return count
        },
        categories(){
            return this.$store.state.category.categories
        },
        brands(){
            return this.$store.state.brand.brands
        },
    },
    methods: {
        defaultItems(){
            return {
                category:[],
                brand:[],
                publish:'',
                facturapi_validation:'',
                inventory_stock:'',
            }
        },
        filter(){
            localStorage.setItem('selectorFiltersInventoryPos', JSON.stringify(this.items))
            localStorage.setItem('filtersInventoryPosLength', this.filtersLength)
            this.$emit("filtersItem", this.items)
        },
        removeFilter(){
            this.items = this.defaultItems()
            localStorage.removeItem('selectorFiltersInventoryPos')
            localStorage.removeItem('filtersInventoryPosLength')
            this.$emit("filtersItem", this.items)
        },
    }
}
</script>
